module.exports = __webpack_public_path__ + "static/Jake Jong-2980a46ebb7dfcdc1a1f809d61e2954c.svg";